import React from 'react';
import Fieldset from '@/components/form/Fieldset/Fieldset';
import FieldGroup from '@/components/form/FieldGroup/FieldGroup';
import Label from '@/components/form/Label/Label';
import { useFormContext } from 'react-hook-form';
import TextArea from '@/components/form/Textarea/TextArea';
import { FormCreateJourneyDataType } from '@/features/forms/CrieSeuRoteiro/validationScheme';
import RadioGroup from '@/components/form/RadioGroup/RadioGroup';
import Radio from '@/components/form/Radio/Radio';
import Text from '@/components/typography/Text/Text';

export interface FormAdditionalInformationProps {}

const FormAdditionalInformation = ({ ...props }: FormAdditionalInformationProps) => {
  const {
    register,
    formState: { errors },
    watch,
  } = useFormContext<FormCreateJourneyDataType>();

  return (
    <Fieldset size="lg" align="center">
      <legend>Incluir informação adicional?</legend>
      <FieldGroup>
        <Label htmlFor="message">Informação adicional</Label>
        <TextArea
          id="message"
          error={errors.message?.message}
          rows={5}
          maxLength={1000}
          helperText="Adicione outros detalhes ou dúvidas que tenha."
          showCounter
          {...register('message')}
        />
      </FieldGroup>
      <RadioGroup label="A passagem aérea já foi comprada?">
        <Radio label="Sim" value="sim" {...register('purchasedFlight')} />
        <Radio label="Não" value="não" {...register('purchasedFlight')} />
        {!watch('purchasedFlight') && errors.purchasedFlight?.message && (
          <Text size="sm" color={'destructive_400'} as="span">
            {errors.purchasedFlight?.message}
          </Text>
        )}
      </RadioGroup>
    </Fieldset>
  );
};

export default FormAdditionalInformation;
